<template>
  <div>
    <h1 class="company-title">会社概要</h1>
    <div class="company-img-box">
      <img class="company-img" src="./img/company_img.png" alt="代表取締役">
    </div>
    <table class="company-table">
      <tbody>
        <tr class="company-table-row">
          <td>
            <div class="company-table-headline">運営企業</div>
          </td>
          <td class="company-table-content">株式会社エンリケ空間</td>
        </tr>
        <tr class="company-table-row">
          <td>
            <div class="company-table-headline">代表取締役</div>
          </td>
          <td class="company-table-content">エンリケ</td>
        </tr>
        <tr class="company-table-row">
          <td>
            <div class="company-table-headline">住所</div>
          </td>
          <td class="company-table-content">〒104-0061 <br>
              東京都中央区銀座8-12-3 SRビル7･8F</td>
        </tr>
        <!--
        <tr class="company-table-row">
          <td>
            <div class="company-table-headline">TEL</div>
          </td>
          <td class="company-table-content">03-6228-4612</td>
        </tr>
        -->
        <tr class="">
          <td>
            <div class="company-table-headline">URL</div>
          </td>
          <td class="company-table-content"><a href="https://enrikekukan.com/">https://enrikekukan.com/</a></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
    // なし
  }
}
</script>

<style scoped>
  @import "../../css/style.css";

  a{
    color: black;
  }

  .company-img-box{
    text-align: center;
    margin-bottom: 30px;
  }

  .company-table-row{
    border-bottom: solid 1px gray;
  }

  /* PC表示 */
  @media screen and (min-width:821px){
    .company-title{
      font-size: 2.5rem;
      letter-spacing: 0.2em;

      color: var(--main-color);
      text-align: center;

      margin:50px auto;
    }

    .company-img{
      width: 70vw;
      
      left: 0;
      right: 0;
      margin: auto;
    }

    .company-table{
      color: black;
      font-size: 24px;
      letter-spacing: 0.2em;
      text-align: left;

      width: 60vw;

      left: 0;
      right: 0;
      margin: auto auto 150px auto;

    }

    .company-table-headline{
      color: var(--main-color);
      padding: 0.8em 0;
    }

    .company-table-content{
      padding: 0.8em 0 0.8em 3em;
      line-height: 2em;
    }
  }
  /* スマホ表示 */
  @media screen and (max-width:820px){
    .company-title{
      font-size: 5vw;
      letter-spacing: 0.2em;

      color: var(--main-color);
      text-align: center;

      margin:1em;
    }

    .company-img{
      width: 95vw;
      
      left: 0;
      right: 0;
      margin: auto;
    }

    .company-table{
      color: black;
      font-size: 12px;
      letter-spacing: 0.2em;
      text-align: left;

      width: 90vw;

      left: 0;
      right: 0;
      margin: auto auto 20px auto;

    }

    .company-table-headline{
      color: var(--main-color);
      padding: 0.8em 0;
      width: 6em;
    }

    .company-table-content{
      padding: 0.8em 0 0.8em 1em;
      line-height: 2em;
    }
  }
</style>